// main.js
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import globalLoader from "./utils/globalLoader";
import { useAuthStore } from "./authen/auth";
import { useAdminAuthStore } from "./authen/adminAuth";
import { useCartStore } from "./cartstore/cartStore";
import { useKidsCartStore } from "./cartstore/kidsCartStore";

const app = createApp(App);

// 1. Init Pinia
const pinia = createPinia();
app.use(pinia);

// 2. Init Router
app.use(router);

// 3. Validate token + restore cart BEFORE app mounts
router.isReady().then(() => {
  const auth = useAuthStore();
  const adminAuth = useAdminAuthStore();
  const cart = useCartStore();
  const kidsCart = useKidsCartStore();

  // Check if access tokens are still valid
  auth.checkToken();
  adminAuth.checkToken();

  // Initialize carts only if token is valid
  cart.initCart();
  kidsCart.initCart();

  // Set up periodic session check to sync cart with auth state
  // Check every 30 seconds to catch session expiration
  setInterval(() => {
    // Check if token expired
    if (!auth.isAuthenticated) {
      if (cart.items.length > 0) cart.syncWithAuth();
      if (kidsCart.items.length > 0) kidsCart.syncWithAuth();
    } else if (auth.isAuthenticated) {
      cart.syncWithAuth();
      kidsCart.syncWithAuth();
    }
  }, 30000); // Check every 30 seconds

  globalLoader.install(app);

  // Mount app only after all session checks
  app.mount("#app");
});
